const appConfig = {
    apiPrefix: 'https://app.anket.edu.az/api',
    //apiPrefix: 'http://192.168.140.196/api',
    authenticatedEntryPath: '/admin',
    unAuthenticatedEntryPath: '/admin/sign-in',
    userUnAuthenticatedEntryPath: '/',
    userAuthenticatedEntryPath: '/user',
    tourPath: '/',
    enableMock: true
}

export default appConfig
